import React, { useState } from "react";
import { useRecoilValue } from 'recoil';
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import PropTypes from 'prop-types';

import { Container, Typography, TextField, Button, IconButton, Box, 
        Dialog, DialogActions, DialogContent, DialogTitle, 
        FormControl, Select,MenuItem } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Close, Cancel, Delete, Save } from '@mui/icons-material';

import { userInfo } from "../../auth/AuthProvider";
import Dialog4Confirm from "./Dialog4Confirm";
import Dialog4Alert from "./Dialog4Alert";
import { useBoardType, useManageBoardInfoQuery } from "../../hooks/useBoard/useCommonQuery";
import { useBoardItemQuery, useBoardItemPostMutation, useBoardItemPutMutation, useBoardItemDeleteMutation, useBoardReplyItemPutMutation, useBoardReplyItemDeleteMutation } from "../../hooks/useBoard/useBoardQuery";
import { Transition, numberCheck } from "../../components/board/ControlUtils";


export default function ControlWriteArticle4Admin (props) {
    const navigate = useNavigate();
    const auth = useRecoilValue(userInfo);
    const { t } = useTranslation();
    const {open, closeEditDialog, isQna, manageId, boardId, refMessage} = props;
    const isLoadingRef = React.useRef(false);
    const refConfirm = React.useRef(null);
    const refAlert = React.useRef(null);
    
    const [pageTitle] = React.useState(manageId === process.env.REACT_APP_BOARD_QNA_MANAGE_ID ? t('nav.board2') : t('nav.board3'));
    const { data: boardTypes } = useBoardType(isQna);
  
    const defaultPostVlues = {ManageId: manageId, BoardId: boardId, BoardTitle: "", BoardType: "", Content: "", ReplyBody: "", BoardHit: 0, BoardOrd: 100 };
    const [editPost, setEditPost] = useState(defaultPostVlues);
    const { data: boardInfo } = useManageBoardInfoQuery(editPost.ManageId);
    
    const { mutate: postBoardItem } = useBoardItemPostMutation();
    const { mutate: putBoardItem } = useBoardItemPutMutation();
    const { mutate: deleteBoardItem } = useBoardItemDeleteMutation();
    const { mutate: putBoardReplyItem } = useBoardReplyItemPutMutation();
    const { mutate: deleteBoardReplayItem } = useBoardReplyItemDeleteMutation();

    const { error: itemArticleError, data: itemArticleData } = useBoardItemQuery(manageId, boardId);
  

    // 게시글 저장 핸들러
    const handleEditPost = () => {
        if((auth.userId === undefined || auth.userId === null || auth.userId === '') || auth?.userType !== process.env.REACT_APP_BOARD_MANAGER_TYPE ) {
            refMessage.openMessage(`${t('error.notlogin')}`);
            setTimeout(() => {
                navigate(`/login`);
            }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
        }
        else if (isValidation()) {
            refConfirm.current.showMessageBox(`${t('button.save')}`, `${t('alert.saveconfirm')}`, (result) => {
                if(result) {
                    if (isLoadingRef.current)  return;
                    isLoadingRef.current = true;
                    // 저장하고
                    let message = JSON.stringify(editPost);

                    if(manageId > 0 && boardId > 0)
                    {
                        if(isQna) {
                            putBoardReplyItem(editPost, {
                                onSuccess: () => {
                                    refAlert.current.showMessageBox(t('button.save'), t('message.updatecomplet'));
                                },
                                onError: (err) => {
                                    let msg = err?.response?.data.detail[0].msg || `${t('error.notprosess')}`;
                                    refAlert.current.showMessageBox(t('error.title'), msg);
                                },
                            });
                        } 
                        else {
                            putBoardItem(editPost, {
                                onSuccess: () => {
                                    refAlert.current.showMessageBox(t('button.save'), t('message.updatecomplet'));
                                },
                                onError: (err) => {
                                    let msg = err?.response?.data.detail[0].msg || `${t('error.notprosess')}`;
                                    refAlert.current.showMessageBox(t('error.title'), msg);
                                },
                            });
                        }
                    }
                    else
                    {
                        postBoardItem(editPost, {
                        onSuccess: () => {
                            refAlert.current.showMessageBox(t('button.save'), t('message.savecomplet'));
                        },
                        });
                    }
                    
                    isLoadingRef.current = false;
                    setEditPost(defaultPostVlues);
                    closeEditDialog(true); // 다이얼로그 닫기
                }
            });
        }
    };

    // 게시글 삭제 핸들러
    const handleDeletePost = (index) => {
        if((auth.userId === undefined || auth.userId === null || auth.userId === '') || auth?.userType !== process.env.REACT_APP_BOARD_MANAGER_TYPE) {
            refMessage.openMessage(`${t('error.notlogin')}`);
            setTimeout(() => {
            closeEditDialog(false);
            navigate(`/login`);
            }, process.env.REACT_APP_REDIRECT_TIME_WAIT);
        }
        else if (isValidation()) {
            refConfirm.current.showMessageBox(`${t('button.delete')}`, `${t('alert.delete')}`, (result) => {
                if(result) {
                    if (isLoadingRef.current)  return;
                    isLoadingRef.current = true;

                    // 삭제하고
                    if(isQna) {
                        deleteBoardReplayItem(editPost.BoardId, {
                            onSuccess: () => {
                            refAlert.current.showMessageBox(t('button.delete'), t('message.deletecomplet'));
                            },
                        });
                    } else {
                        deleteBoardItem(editPost.BoardId, {
                            onSuccess: () => {
                            refAlert.current.showMessageBox(t('button.delete'), t('message.deletecomplet'));
                            },
                        });
                    }

                    isLoadingRef.current = false;
                    setEditPost(defaultPostVlues);
                    closeEditDialog(true);; // 다이얼로그 닫기
                }
            });
        }
    };
    
    const isValidation = () => {
        if (editPost?.ManageId === undefined || editPost?.ManageId === null || editPost?.ManageId < 1)
        {
            refAlert.current.showMessageBox(t('alert.title'), `[${t('field.manageid')}] ${t('error.emptyvalue')}`);
            return false;
        }

        if (boardId > 0 && (editPost?.BoardId === undefined || editPost?.BoardId === null || editPost?.BoardId < 1))
        {
            refAlert.current.showMessageBox(t('alert.title'), `[${t('field.boardid')}] ${t('error.emptyvalue')}`);
            return false;
        }
        
        if (editPost?.BoardTitle === undefined || editPost?.BoardTitle === null || editPost?.BoardTitle === '')
        {
            refAlert.current.showMessageBox(t('alert.title'), `[${t('field.boardtitle')}] ${t('error.emptyvalue')}`);
            return false;
        }
        
        if (editPost?.Content === undefined || editPost?.Content === null || editPost?.Content === '')
        {
            refAlert.current.showMessageBox(t('alert.title'), `[${t('field.content')}] ${t('error.emptyvalue')}`);
            return false;
        }
        
        if (boardInfo?.OrdYn === 'Y') {
            if (editPost?.BoardOrd === undefined || editPost?.BoardOrd === null) {
                refAlert.current.showMessageBox(t('alert.title'), `[${t('field.boardord')}] ${t('error.emptyvalue')}`);
                return false;
            }
        }
        
        if (isQna && boardId > 0) {
            if(editPost?.ReplyBody === undefined || editPost?.ReplyBody === null || editPost?.ReplyBody === '') {
                refAlert.current.showMessageBox(t('alert.title'), `[${t('field.replybody')}] ${t('error.emptyvalue')}`);
                return false;
            }
        }
        return true;
    };

    // 다이얼로그 닫기
    const handleCloseDialog = () => {
        setEditPost(defaultPostVlues);
        closeEditDialog(false);
    };


    React.useEffect(() => {
        document.title = 'BWOB - ' + pageTitle;
        return () => {
            setEditPost(defaultPostVlues);
        }
    }, [open]);
        
    React.useEffect(() => {
        try {
            if (itemArticleData !== undefined && itemArticleData !== null) {
                setEditPost(itemArticleData);
            }
        }
        catch(err)
        {
            console.log(new Date().toISOString(), itemArticleData, err);
        }
    }, [itemArticleError, itemArticleData]);

    
    return (
        <Container maxWidth="lg" style={{ marginTop: "10px" }}>

            {/* 게시글 수정 다이얼로그 */}
            <Dialog open={open} TransitionComponent={Transition} fullWidth={true} maxWidth={"lg"} 
                    onClose={handleCloseDialog} 
                    scroll="paper"
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
            >
                <DialogTitle>
                    <Typography variant="h5" gutterBottom align="center">
                    {pageTitle}
                    &nbsp;&nbsp;
                    {(() => {
                        let dialogTitle;
                        if (manageId > 0 && boardId > 0) {
                            dialogTitle = isQna ? t('others.reply') : t('button.modify');
                        } else {
                            dialogTitle = t('button.registration');
                        }
                        return dialogTitle;
                    })()}
                </Typography>

                </DialogTitle>
                <Box position="absolute" top={0} right={0}>
                    <IconButton onClick={() => handleCloseDialog()}>
                        <Close />
                    </IconButton>
                </Box>
                
                <DialogContent dividers>
                    <Container sx={{ p: 1 }}>
                        <Grid container alignItems="center" spacing={1} sx={{  '--Grid-borderWidth': '1px',
                                                                                borderColor: 'divider',
                                                                                '& > div.divline': {
                                                                                    borderTop: 'var(--Grid-borderWidth) dotted',
                                                                                    borderColor: 'divider',
                                                                                    lineHeight: '3px',
                                                                                    height: '3px',
                                                                                },
                        }}>
                            <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                                <Typography id="manageid-select-small-label" component="div" sx={{ flexGrow: 1 }} color="primary">
                                    {t('field.boardtype')}   
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                                <FormControl sx={{ m: 0, p: 0, minWidth: 200, width: "100%" }} size="small" disabled={editPost.BoardId > 0}>
                                    <Select
                                        labelId="manageid-select-small-label"
                                        id="manageid-select-small"
                                        placeholder={t('others.selectone')}
                                        value={editPost?.ManageId || ''}
                                        onChange={(v) => setEditPost({...editPost, ManageId:v.target.value}) }
                                        size="small"
                                        
                                    >
                                        <MenuItem value=''>
                                            <em>{t('others.selectone')}</em>
                                        </MenuItem>
                                        {boardTypes ? boardTypes?.map(item => {
                                            return <MenuItem key={item.ManageId} value={item.ManageId}>{item.BoardName}</MenuItem>
                                        }) : null }
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                            <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                                <Typography component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                                {t('field.boardtitle')}
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                                <TextField id="board_reg_title" label="" variant="outlined" size="small" fullWidth disabled={false}
                                        value={editPost.BoardTitle} onChange={(e) => setEditPost({...editPost, BoardTitle:e.target.value})} />
                            </Grid>

                            <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                            <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                                <Typography component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                                    <Trans i18nKey='field.content' />
                                </Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                                <TextField id="board_content" label="" variant="outlined" size="small" fullWidth
                                    multiline={true} minRows={15} maxRows={120} disabled={false}
                                    value={editPost.Content} onChange={(e) => setEditPost({...editPost, Content:e.target.value})} />
                            </Grid>

                            {(isQna && auth?.userType === process.env.REACT_APP_BOARD_MANAGER_TYPE) ?
                                <>
                                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                                    <Typography component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                                        <Trans i18nKey='field.replybody' />
                                    </Typography>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                                    <TextField id="board_reg_reply" label="" variant="outlined" size="small" fullWidth 
                                            multiline={true} minRows={10} maxRows={120} disabled={false}
                                            value={editPost.ReplyBody} onChange={(e) => setEditPost({...editPost, ReplyBody:e.target.value})} />
                                </Grid>
                                </> : null
                            }
                            {(boardInfo?.OrdYn === 'Y' && auth?.userType === process.env.REACT_APP_BOARD_MANAGER_TYPE) ?
                                <>
                                <Grid item className="divline" size={{ xs: 12, sm: 12, md: 12,  }} />
                                <Grid item size={{ xs: 12, sm: 2, md: 2 }} sx={{ }} >
                                    <Typography component="div" sx={{ flexGrow: 1, textAlign: "center" }} color="primary">
                                        {t('field.boardord')}
                                    </Typography>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 10, md: 10 }} sx={{ paddingRight: '10px'}} >
                                    <TextField id="board_reg_ord" label="" variant="outlined" size="small" fullWidth 
                                            value={editPost.BoardOrd} onChange={(e) => setEditPost({...editPost, BoardOrd:numberCheck(e.target.value)})} />
                                </Grid>
                                </> : null
                            }

                        </Grid>
                    </Container>

                </DialogContent>
                
                <DialogActions>

                    <Button onClick={handleCloseDialog} startIcon={<Cancel />} color="primary" variant="contained" sx={{ paddingLeft: '35px', paddingRight: '35px', marginRight: '30px', marginTop: '5px' }} >
                    {t('button.cancel')}
                    </Button>
                    <Button onClick={handleDeletePost} startIcon={<Delete />} color="primary" variant="contained" sx={{ paddingLeft: '35px', paddingRight: '35px', marginRight: '30px', marginTop: '5px' }} >
                    {t('button.delete')}
                    </Button>
                    <Button onClick={handleEditPost} startIcon={<Save />} color="secondary" variant="contained" sx={{ paddingLeft: '35px', paddingRight: '35px', marginRight: '30px', marginTop: '5px' }} >
                    {t('button.save')}
                    </Button>

                </DialogActions>
            </Dialog>
            <Dialog4Alert ref={refAlert} />
            <Dialog4Confirm ref={refConfirm} />
        </Container>
    );
};

ControlWriteArticle4Admin.propTypes = {
    open: PropTypes.bool.isRequired, 
    closeEditDialog: PropTypes.func.isRequired, 
    isQna: PropTypes.bool.isRequired,
    manageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    boardId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), 
    refMessage: PropTypes.object
};